import React, { useEffect, useState } from 'react'
import { DatePicker, Form, InputNumber, Modal, message } from 'antd'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import fetchAPI from '../../../../../../lib/utils/fetch-api'
import { COMPLIANCE_LABELS, isReceiptType, type ComplianceType } from '../../types/compliance'

interface ComplianceAddModalProps {
  open: boolean
  employeeId: number
  type: ComplianceType
  onClose: () => void
  onSuccess: () => void
}

interface FormValues {
  expires_at: Dayjs
  amount?: number
}

export function ComplianceAddModal({
  open,
  employeeId,
  type,
  onClose,
  onSuccess,
}: ComplianceAddModalProps) {
  const [form] = Form.useForm<FormValues>()
  const [submitting, setSubmitting] = useState(false)
  const isReceipt = isReceiptType(type)

  useEffect(() => {
    if (open) {
      if (isReceipt) {
        form.setFieldsValue({ expires_at: dayjs(), amount: undefined })
      } else {
        form.resetFields()
      }
    }
  }, [open, form, isReceipt])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setSubmitting(true)
      const body: Record<string, unknown> = {
        type,
        expires_at: values.expires_at.format('YYYY-MM-DD'),
      }
      if (isReceipt) {
        body.amount = values.amount
      }
      const response = await fetchAPI(`/api/hr/employees/${employeeId}/compliance`, {
        method: 'POST',
        body: JSON.stringify(body),
      })
      if (response?.errors) {
        message.error('Не удалось сохранить запись')
        return
      }
      message.success('Запись добавлена')
      onSuccess()
      onClose()
    } catch {
      // validation or network
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title={`Добавить: ${COMPLIANCE_LABELS[type]}`}
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={submitting}
      okText="Сохранить"
      cancelText="Отмена"
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        {isReceipt && (
          <Form.Item
            name="amount"
            label="Сумма"
            rules={[{ required: true, message: 'Укажите сумму' }]}
          >
            <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
          </Form.Item>
        )}
        <Form.Item
          name="expires_at"
          label={isReceipt ? 'Дата добавления' : 'Дата окончания'}
          rules={[
            {
              required: true,
              message: isReceipt ? 'Укажите дату' : 'Укажите дату окончания',
            },
          ]}
        >
          <DatePicker format="DD.MM.YYYY" style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
